import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../../api/axios";

export const validateSetupToken = createAsyncThunk(
  "accountSetup/validateToken",
  async (token, { rejectWithValue }) => {
    try {
      const response = await api.post(
        "/api/v1/power/account-setup/validate-token",
        { token },
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error?.message || "Ongeldige of verlopen uitnodiging.",
      );
    }
  },
);

export const startAccountSetup = createAsyncThunk(
  "accountSetup/start",
  async ({ token, password, confirmPassword }, { rejectWithValue }) => {
    try {
      const response = await api.post("/api/v1/power/account-setup/start", {
        token,
        password,
        confirmPassword,
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error?.message || "Account setup kon niet gestart worden.",
      );
    }
  },
);

export const verifySetupMfa = createAsyncThunk(
  "accountSetup/verifyMfa",
  async ({ token, code }, { rejectWithValue }) => {
    try {
      const response = await api.post(
        "/api/v1/power/account-setup/verify-mfa",
        {
          token,
          code,
        },
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error?.message || "MFA-code is ongeldig of verlopen.",
      );
    }
  },
);

const initialState = {
  tokenStatus: "idle",
  startStatus: "idle",
  mfaStatus: "idle",

  inviteData: null,
  mfaData: null,

  error: null,
};

const accountSetupSlice = createSlice({
  name: "accountSetup",
  initialState,
  reducers: {
    resetAccountSetup: () => initialState,
    clearAccountSetupError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder

      // VALIDATE TOKEN
      .addCase(validateSetupToken.pending, (state) => {
        state.tokenStatus = "loading";
        state.error = null;
      })
      .addCase(validateSetupToken.fulfilled, (state, action) => {
        state.tokenStatus = "valid";
        state.inviteData = action.payload?.data || null;
        state.error = null;
      })
      .addCase(validateSetupToken.rejected, (state, action) => {
        state.tokenStatus = "invalid";
        state.inviteData = null;
        state.error = action.payload || "Ongeldige of verlopen uitnodiging.";
      })

      // START ACCOUNT SETUP
      .addCase(startAccountSetup.pending, (state) => {
        state.startStatus = "loading";
        state.error = null;
      })
      .addCase(startAccountSetup.fulfilled, (state, action) => {
        state.startStatus = "success";
        state.mfaData = action.payload?.data || null;
        state.error = null;
      })
      .addCase(startAccountSetup.rejected, (state, action) => {
        state.startStatus = "error";
        state.error =
          action.payload || "Account setup kon niet gestart worden.";
      })

      // VERIFY MFA
      .addCase(verifySetupMfa.pending, (state) => {
        state.mfaStatus = "loading";
        state.error = null;
      })
      .addCase(verifySetupMfa.fulfilled, (state) => {
        state.mfaStatus = "success";
        state.error = null;
      })
      .addCase(verifySetupMfa.rejected, (state, action) => {
        state.mfaStatus = "error";
        state.error = action.payload || "MFA-code is ongeldig.";
      });
  },
});

export const { resetAccountSetup, clearAccountSetupError } =
  accountSetupSlice.actions;

export default accountSetupSlice.reducer;
